import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getKycDetails = async (queryParams:any) => {
    try {
  return await get<ApiResponse<[]>>(`/kyc/details?${queryParams}`).then((res)=>{
    if(res?.success===true){
      
        return res
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
